<div>
   <div class="row mb-3">
      <div class="col-sm-6">
         <button type="button" class="btn btn-primary" (click)="back()">
            <span>Back</span>
         </button>
      </div>
      <div class="col-sm-6 d-flex justify-content-end">
         <button type="button" class="btn btn-primary" (click)="download()">
            <span *ngIf="!downloadQuoteLoading">Download</span>
            <span *ngIf="downloadQuoteLoading"><i class="fa fa-spinner fa-spin"></i> Downloading</span>
         </button>
      </div>
   </div>
   <div class="card">
      <div class="row">
         <div class="col-md-12">
            <img src="./assets/icons/bluelogo.png" height="60" class="mb-3" alt="Kwikspace">
         </div>
      </div>

      <div class="row">
         <div class="col-md-12 col-sm-12 ml-2">
            <h5 class="title-heading">Rental Quotation</h5>
         </div>
      </div>
      <div class="row">
         <div class="col-md-2"></div>
         <div class="col-md-5 col-sm-12">
            <div class="row" *ngIf="isStaff">
               <div class="col-md-6 col-sm-6">
                  <strong>Customer account number</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ quote.customerAccountNumber }}
               </div>
            </div>
            <div class="row">
               <div class="col-md-6 col-sm-6">
                  <strong>Company</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ quote.customer.company.name }}
               </div>
            </div>
            <div class="row d-flex justify-content-end">
               <div class="col-md-6 col-sm-6">
                  <strong>Attention</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ quote.customer.firstName }} {{ quote.customer.lastName }}
               </div>
            </div>
            <div class="row d-flex justify-content-end">
               <div class="col-md-6 col-sm-6">
                  <strong>Contact No</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ quote.customer.company.contactNumber }}
               </div>
            </div>
            <div class="row d-flex justify-content-end">
               <div class="col-md-6 col-sm-6">
                  <strong>Cell No</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ quote.customer.company.cellNumber }}
               </div>
            </div>
            <div class="row d-flex justify-content-end">
               <div class="col-md-6 col-sm-6">
                  <strong>Email</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ quote.customer.email }}
               </div>
            </div>
            <div class="row d-flex justify-content-end" *ngIf="quote.lineItems.length > 0">
               <div class="col-md-6 col-sm-6">
                  <strong>Rental Period</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ contractLength }} Month(s)
               </div>
            </div>
            <div class="row d-flex justify-content-end">
               <div class="col-md-6 col-sm-6">
                  <strong>Acc# / Site</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ quote.customer.company.name }} <br>
                  {{ quote.shippingProvince.name }}
               </div>
            </div>
         </div>
         <div class="col-md-5 col-sm-12">
            <div class="row" *ngIf="isStaff">
               <div class="col-md-6 col-sm-6">
                  <strong>Customer site allocation</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ quote.siteAllocation }}
               </div>
            </div>
            <div class="row">
               <div class="col-md-6 col-sm-6">
                  <strong>Date</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ quote.createdDate| date:'mediumDate'}}
               </div>
            </div>
            <div class="row">
               <div class="col-md-6 col-sm-6">
                  <strong>Date modified</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ quote.modifiedDate| date:'mediumDate'}}
               </div>
            </div>
            <div class="row d-flex justify-content-end">
               <div class="col-md-6 col-sm-6">
                  <strong>From</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ quote.quoteOwner.user.firstName }} {{ quote.quoteOwner.user.lastName }}
               </div>
            </div>
            <div class="row d-flex justify-content-end">
               <div class="col-md-6 col-sm-6">
                  <strong>Our Reference</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ quote.quoteNumber }}
               </div>
            </div>
            <div class="row d-flex justify-content-end">
               <div class="col-md-6 col-sm-6">
                  <strong>Market Segment</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ quote.organization.name }}
               </div>
            </div>
            <div class="row d-flex justify-content-end">
               <div class="col-md-6 col-sm-6">
                  <strong>Your Reference</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ quote.yourReference }}
               </div>
            </div>

            <div class="row d-flex justify-content-end">
               <div class="col-md-6 col-sm-6">
                  <strong>Quote Validity</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ quote.quoteValidity.validFor }}
               </div>
            </div>
            <div class="row d-flex justify-content-end">
               <div class="col-md-6 col-sm-6">
                  <strong>Bill to</strong>
               </div>
               <div class="col-md-6 col-sm-6">
                  {{ quote.customer.company.name }}
                  <br> {{ quote.shippingProvince.name }}
               </div>
            </div>

         </div>
      </div>
      <hr class="ml-2 mr-2" size="10" noshade>
      <div class="row">
         <div class="col-md-12 col-sm-12">
            <p class="ml-2">Dear Sir/Madam <br> We take pleasure in submitting our official quotation for Rental of
               Prefabricated building(s) for your consideration as follows</p>
         </div>
      </div>

      <ng-container *ngIf="quote.lineItems.length > 0">
         <div class="row ml-2 mr-2 col-heading">
            <div class="col-sm-1">
               No.
            </div>
            <div class="col-sm-3">
               Description
            </div>
            <div class="col-sm-1 d-flex justify-content-center">
               QTY
            </div>
            <div class="col-sm-2 d-flex justify-content-center">
               Price per Unit
            </div>
            <div class="col-sm-2 d-flex justify-content-center">
               Initial Payment
            </div>
            <div class="col-sm-1 d-flex justify-content-center">
               Period
            </div>
            <div class="col-sm-2 d-flex justify-content-center">
               Monthly Rent
            </div>
         </div>

         <ng-container *ngFor="let item of quote.lineItems">
            <div class="row ml-2 mr-2">
               <div class="col-sm-12">
                  {{ item.name }}
               </div>
            </div>
            <!-- Rental price rows -->
            <div class="row ml-2 mr-2 item-row pb-2">
               <div class="col-sm-1"></div>
               <div class="col-sm-3">
                  {{ item.rentalOption.name }}
               </div>
               <div class="col-sm-1 d-flex justify-content-center">
                  {{ item.quantity }}
               </div>
               <div class="col-sm-2 text-right">
                  <div *ngIf="item.discountAmount == null; else discountAmt">
                     {{ item.rentalOption.monthlyRate | currency:'ZAR':'R ' }}
                  </div>
                  <ng-template #discountAmt>
                     {{ item.discountAmount | currency:'ZAR':'R ' }}
                  </ng-template>
               </div>
               <div class="col-sm-2 text-right">
                  {{ item.initPmt | currency:'ZAR':'R ' }}
               </div>
               <div class="col-sm-1 d-flex justify-content-center">
                  {{ item.rentalPeriod }}
               </div>
               <div class="col-sm-2 text-right">
                  {{ item.initPmt | currency:'ZAR':'R ' }}
               </div>
            </div>

            <!-- Product addon price rows -->
            <ng-container *ngIf="item.productConfigurations.length > 0">
               <div class="row ml-2 mr-2 item-row mt-2 pb-2" *ngFor="let addon of item.productConfigurations">
                  <div class="col-sm-1"></div>
                  <div class="col-sm-3">
                     {{ addon.product.name }}
                  </div>
                  <div class="col-sm-1 d-flex justify-content-center">
                     {{ addon.quantity }}
                  </div>
                  <div class="col-sm-2 text-right">{{ addon.unitPrice | currency:'ZAR':'R ' }}</div>
                  <div class="col-sm-2 text-right">{{ addon.initPmt | currency:'ZAR':'R ' }}</div>
                  <div class="col-sm-1 d-flex justify-content-center">{{ addon.period }}</div>
                  <div class="col-sm-2 text-right">{{ addon.monthlyPmt | currency:'ZAR':'R ' }}</div>
               </div>
            </ng-container>

            <!-- Damage deposit -->
            <div class="row ml-2 mr-2 item-row mt-2 pb-2">
               <div class="col-sm-1"></div>
               <div class="col-sm-3">Damage Deposit</div>
               <div class="col-sm-1 d-flex justify-content-center">{{ item.quantity }}</div>
               <div class="col-sm-2 text-right">{{ item.unitDeposit | currency:'ZAR':'R ' }}</div>
               <div class="col-sm-2 text-right">{{ item.deposit | currency:'ZAR':'R ' }}</div>
               <div class="col-sm-1"></div>
               <div class="col-sm-2 text-right"></div>
            </div>

            <!-- Delivery price rows -->
            <div class="row ml-2 mr-2 item-row mt-2 pb-2" *ngIf="item.deliveryCharge">
               <div class="col-sm-1"></div>
               <div class="col-sm-3">
                  Delivery and Collection -
                  {{ item.deliveryCharge.transportLocation.name }} -
                  {{ item.deliveryCharge.loadSize.size }}
               </div>
               <div class="col-sm-1 d-flex justify-content-center">
                  {{ item.deliveryChargeQty }}
               </div>
               <div class="col-sm-2 text-right">{{ item.deliveryCharge.initPrice | currency:'ZAR':'R ' }}</div>
               <div class="col-sm-2 text-right">{{ item.deliveryCharge.price | currency:'ZAR':'R ' }}</div>
               <div class="col-sm-1"></div>
               <div class="col-sm-2 text-right"></div>
            </div>
            <div class="row ml-2 mr-2 item-row mt-2 pb-2" *ngIf="item.deliveryChargeExtra">
               <div class="col-sm-1"></div>
               <div class="col-sm-3">
                  Delivery and Collection -
                  {{ item.deliveryChargeExtra.transportLocation.name }} -
                  {{ item.deliveryChargeExtra.loadSize.size }}
               </div>
               <div class="col-sm-1 d-flex justify-content-center">
                  {{ item.deliveryChargeExtraQty }}
               </div>
               <div class="col-sm-2 text-right">{{ item.deliveryChargeExtra.initPrice | currency:'ZAR':'R ' }}</div>
               <div class="col-sm-2 text-right">{{ item.deliveryChargeExtra.price | currency:'ZAR':'R ' }}</div>
               <div class="col-sm-1"></div>
               <div class="col-sm-2 text-right"></div>
            </div>

            <!-- Joining price rows -->
            <div class="row ml-2 mr-2 item-row mt-2 pb-2" *ngIf="item.deliveryChargeOptional">
               <div class="col-sm-1"></div>
               <div class="col-sm-3">
                  Siting and Dismantling -
                  {{ item.deliveryChargeOptional.transportLocation.district.name }} -
                  {{ item.deliveryChargeOptional.transportLocation.name }}
               </div>
               <div class="col-sm-1 d-flex justify-content-center">
                  {{ item.deliveryChargeJoinQty }}
               </div>
               <div class="col-sm-2 text-right">{{ item.deliveryChargeOptional.initPrice | currency:'ZAR':'R ' }}</div>
               <div class="col-sm-2 text-right">{{ item.deliveryChargeOptional.price | currency:'ZAR':'R ' }}</div>
               <div class="col-sm-1"></div>
               <div class="col-sm-2 text-right"></div>
            </div>

            <div class="row ml-2 mr-2 item-row mt-2 pb-2" *ngIf="item.deliveryChargeDiscounted">
               <div class="col-sm-1"></div>
               <div class="col-sm-3">
                  Siting and Dismantling -
                  {{ item.deliveryChargeDiscounted.name }}
               </div>
               <div class="col-sm-1 d-flex justify-content-center">
                  {{ item.deliveryChargeDiscountedQty }}
               </div>
               <div class="col-sm-2 text-right">{{ item.deliveryChargeDiscounted.discountAmount | currency:'ZAR':'R ' }}
               </div>
               <div class="col-sm-2 text-right">{{ item.deliveryChargeDiscounted.discountAmount | currency:'ZAR':'R ' }}
               </div>
               <div class="col-sm-1"></div>
               <div class="col-sm-2 text-right"></div>
            </div>

            <!-- sub total row -->
            <div class="row ml-2 mr-2 sub-total-row">
               <div class="col-sm-1"></div>
               <div class="col-sm-4">Sub Total (excl)</div>
               <div class="col-sm-2"></div>
               <div class="col-sm-2 text-right">{{ item.initSub | currency:'ZAR':'R ' }}</div>
               <div class="col-sm-1"></div>
               <div class="col-sm-2 text-right">{{ item.monthlySub | currency:'ZAR':'R ' }}</div>
            </div>

         </ng-container>
      </ng-container>

      <hr class="ml-2 mr-2" size="10" noshade>

      <div class="row mt-2 mb-2 mr-0">
         <div class="col-sm-12">
            <table class="quote-extras-table">
               <tbody class="quote-items">
                  <tr>
                     <td><span class="table-title">Contract Summary (excl)</span></td>
                     <td></td>
                     <td class="text-right">Initial Payment</td>
                     <td class="text-right">Monthly Rent</td>
                  </tr>
                  <tr>
                     <td> - Initial Amount</td>
                     <td>Rent</td>
                     <td class="text-right">{{ monthlyRental | currency:'ZAR':'R ' }}</td>
                     <td class="text-right"></td>
                  </tr>
                  <tr>
                     <td></td>
                     <td>Damage Deposit</td>
                     <td class="text-right">{{ damageDeposit | currency:'ZAR':'R ' }}</td>
                     <td class="text-right"></td>
                  </tr>
                  <tr>
                     <td></td>
                     <td>Transport & Siting</td>
                     <td class="text-right">{{ initTransport | currency:'ZAR':'R ' }}</td>
                     <td class="text-right"></td>
                  </tr>
                  <tr>
                     <td></td>
                     <td>Sub Total</td>
                     <td class="text-right">{{ initSubTotal | currency:'ZAR':'R ' }}</td>
                     <td class="text-right"></td>
                  </tr>
                  <tr>
                     <td> - Monthly Rental Amount</td>
                     <td>Sub Total</td>
                     <td class="text-right"></td>
                     <td class="text-right">{{ monthlyRental | currency:'ZAR':'R ' }}</td>
                  </tr>
               </tbody>
            </table>
         </div>
      </div>

      <hr class="ml-2 mr-2" size="10" noshade>

      <div class="row mt-2 mb-2 mr-0">
         <div class="col-sm-12">
            <p class="ml-2">Please Note: The transport price has been provided as an estimate.</p>
            <p class="ml-2">Please contact a Kwikspace representative for discounted rates, where units can be placed on
               combined truck sizes.</p>
         </div>
      </div>

      <hr class="ml-2 mr-2" size="10" noshade>
		
		<div class="row mt-2 mb-2 mr-0">
			<div class="col-sm-12">
				<p class="ml-2">The installation of air conditioners is excluded and can be provided by your account manager on request.</p>
			</div>
		</div>

      <ng-container>
         <hr class="ml-2 mr-2" size="10" noshade>

         <div class="row mt-2 mb-2 mr-0">
            <div class="col-sm-12">
               <p class="ml-2">Prices exclude Medical, Induction, Safety File, Tool tagging</p>
               <p class="ml-2">and any required Covid Testing.</p>
            </div>
         </div>
      </ng-container>

      <hr class="ml-2 mr-2" size="10" noshade *ngIf="displayEscalation">

      <div class="row mt-2 mb-2 mr-0">
         <div class="col-sm-12">
            <p class="ml-2">Please Note: The transport price has been provided as an estimate.</p>
            <p class="ml-2">Please contact a Kwikspace representative for discounted rates, where units can be placed on combined truck sizes.</p>
         </div>
      </div>

      <hr class="ml-2 mr-2" size="10" noshade *ngIf="displayEscalation">

      <div class="row mt-2 mb-2 mr-0" *ngIf="displayEscalation">
         <div class="col-sm-12">
            <table class="quote-extras-table">
               <tbody class="quote-items">
                  <tr>
                     <td><span class="table-title">Escalation at 10% per Year</span></td>
                     <td></td>
                     <td class="text-right">No of Months</td>
                     <td class="text-right">Amount Incl Esc per year</td>
                  </tr>
                  <tr>
                     <td></td>
                     <td>Year 1</td>
                     <td class="text-right">{{ yearOneMonths }}</td>
                     <td class="text-right">{{ yearOneAmount | currency:'ZAR':'R ' }}</td>
                  </tr>
                  <tr *ngIf="yearTwo">
                     <td></td>
                     <td>Year 2</td>
                     <td class="text-right">{{ yearTwoMonths }}</td>
                     <td class="text-right">{{ yearTwoAmount | currency:'ZAR':'R ' }}</td>
                  </tr>
                  <tr *ngIf="yearThree">
                     <td></td>
                     <td>Year 3</td>
                     <td class="text-right">{{ yearThreeMonths }}</td>
                     <td class="text-right">{{ yearThreeAmount | currency:'ZAR':'R ' }}</td>
                  </tr>
               </tbody>
            </table>
         </div>
      </div>

      <hr class="ml-2 mr-2" size="10" noshade>

      <div class="row mt-2 mb-2 pl-2 pr-3">
         <div class="col-sm-10">
            <p class="mb-0"><b>Contract Total (VAT Excl.) (Total Rental Fee including 10.00% Annual Escalation + Return
                  Transport + Damage Deposit) where applicable.</b></p>
         </div>
         <div class="col-sm-2 text-right align-self-end">
            <p class="mb-0"><b>{{ contractTotal | currency:'ZAR':'R ' }}</b></p>
         </div>
      </div>

      <hr class="ml-2 mr-2" size="10" noshade>

      <div class="row mt-2 mb-2 mr-0">
         <div class="col-sm-12">
            <table class="quote-extras-table">
               <tbody class="quote-items">
                  <tr>
                     <td><span class="table-title">Grand Totals (Incl) - E&OE</span></td>
                     <td>Sub Total</td>
                     <td class="text-right">{{ initSubTotal | currency:'ZAR':'R ' }}</td>
                     <td class="text-right">{{ monthlyRental | currency:'ZAR':'R ' }}</td>
                  </tr>
                  <tr>
                     <td></td>
                     <td>VAT</td>
                     <td class="text-right">{{ initSubVat | currency:'ZAR':'R ' }}</td>
                     <td class="text-right">{{ monthlySubVat | currency:'ZAR':'R ' }}</td>
                  </tr>
                  <tr>
                     <td></td>
                     <td>Total Due</td>
                     <td class="text-right">{{ initTotal | currency:'ZAR':'R ' }}</td>
                     <td class="text-right">{{ monthlyTotal | currency:'ZAR':'R ' }}</td>
                  </tr>
               </tbody>
            </table>
         </div>
      </div>

      <hr class="ml-2 mr-2" size="10" noshade>

      <div class="row mt-2 mb-2 mr-0">
         <div class="ml-2 col-sm-12">
            <div class="row">
               <div class="col-md-4 col-sm-6">
                  <span>Sales consultant</span>
               </div>
               <div class="col-md-4 col-sm-6">
                  <span>{{ quote.quoteOwner.user.firstName }} {{ quote.quoteOwner.user.lastName }}</span>
               </div>
            </div>
            <div class="row">
               <div class="col-md-4 col-sm-6">
                  <span>Email</span>
               </div>
               <div class="col-md-4 col-sm-6">
                  <span>{{ quote.quoteOwner.user.email }}</span>
               </div>
            </div>
         </div>
      </div>

      <ng-container *ngIf="isStaff && quote.notes != ''">
         <hr class="ml-2 mr-2" size="10" noshade>

         <div class="row mt-2 mr-0">
            <div class="ml-2 col-sm-12">
               <span><b>Notes:</b></span>
            </div>
         </div>
         <div class="row mt-2 mb-2 mr-0">
            <div class="ml-2 col-sm-12">
               <span>{{ quote.notes }}</span>
            </div>
         </div>
      </ng-container>

      <hr class="ml-2 mr-2" size="10" noshade>

      <div class="row mt-2 mb-2 mr-0 ml-0">
         <div class="col-sm-12 accordion-wrapper">
            <h4 class="">Terms & Conditions</h4>
            <ngb-accordion>
               <ngb-panel id="static-1">
                  <ng-template ngbPanelTitle>
                     <span>Placing of Orders</span>
                  </ng-template>
                  <ng-template ngbPanelContent>
                     <p>All new clients will be required to complete and return a credit application that is subject
                        to approval by the National Credit Manager in order to open an account.</p>

                     <p>The following documentation is required upon placement of an order</p>

                     <ol>
                        <li>Purchase order that is aligned to the Kwikspace quotation.</li>
                        <li>Delivery address or map to site.</li>
                        <li>Two site contacts and mobile contact numbers for delivery of buildings to site.</li>
                     </ol>

                     <p class="mb-1"><b>Escalation</b></p>

                     <p>Annual price escalation after each completed 12-month term - 10.00% (Ten Percent).</p>
                     <p>Total monthly rental: {{ monthlyTotal | currency:'ZAR':'R ' }}</p>
                     <p>Rental period: {{ contractLength }} Month(s)</p>
                     <p>Contract total: {{ contractTotal | currency:'ZAR':'R ' }}</p>

                  </ng-template>
               </ngb-panel>

               <ngb-panel id="static-2">
                  <ng-template ngbPanelTitle>
                     <span>Price</span>
                  </ng-template>
                  <ng-template ngbPanelContent>
                     <p>The amount quoted in our quotation is exclusive of Vat, and makes no allowance for customs,
                        duties, clearing charges, import and export
                        taxes as well as all other border related cost.</p>

                     <p>Unless otherwise stated in our quotation it is open for acceptance within thirty (30)
                        calendar days from date thereof. </p>
                  </ng-template>
               </ngb-panel>

               <ngb-panel id="static-3">
                  <ng-template ngbPanelTitle>
                     <span>Payment</span>
                  </ng-template>
                  <ng-template ngbPanelContent>
                     <p>One month’s rental and full transport costs (delivery & collection) payable in advance,
                        thereafter monthly rental in advance.</p>
                     <ul>
                        <li>A deposit equal to one month’s rental payable prior to dispatch, the deposit is
                           refundable on return of the goods, fair wear and tear expected.</li>
                        <li>A one month’s notice is required on termination of the rental agreement.</li>
                        <li>A signed rental agreement to be in place prior to dispatch of goods.</li>
                        <li>Prices are quoted in South African Rands (ZAR) and are payable in South Africa.</li>
                        <li>Interest of 3% per month will be charged on all overdue accounts.</li>
                     </ul>
                  </ng-template>
               </ngb-panel>

               <ngb-panel id="static-5">
                  <ng-template ngbPanelTitle>
                     <span>Delivery Period</span>
                  </ng-template>
                  <ng-template ngbPanelContent>
                     <p>Delivery as specified in our official quotation</p>
                     <p class="mb-1">This period is subject to the following:</p>
                     <ul>
                        <li>Receipt of official purchase order</li>
                        <li>Proof of payment</li>
                        <li>Signed rental agreement to be in place prior to dispatch of goods.</li>
                        <li>Our existing commitments at the time of receipt of order.</li>
                     </ul>
                     <p>While we shall make every effort to complete on or within the above period, we record that
                        delays may be incurred that are beyond our control.
                        The purchaser shall not be entitled to claim cancellation of the sale by reason of late
                        delivery, nor shall the purchaser be entitled to claim
                        damages or penalties whether direct or consequential by reason of late delivery</p>
                     <p>Weather conditions might delay delivery or collection.</p>
                     <p><b>All units are subject to stock availability.</b></p>
                  </ng-template>
               </ngb-panel>

               <ngb-panel id="static-6">
                  <ng-template ngbPanelTitle>
                     <span>Units</span>
                  </ng-template>
                  <ng-template ngbPanelContent>
                     <p>South African electrical standards have been assumed.</p>
                     <p>South African building standards have been used for all plumbing.</p>
                     <p>All rental buildings are standard rental fleet units.</p>
                     <p>Please note that drawings supplied are for indication purposes only. Window, door and other
                        configurations might differ from drawings provided
                        depending on stock availability at the time of order</p>
                  </ng-template>
               </ngb-panel>

               <ngb-panel id="static-7">
                  <ng-template ngbPanelTitle>
                     <span>Transportation</span>
                  </ng-template>
                  <ng-template ngbPanelContent>
                     <p>Our transportation costs are based upon current fuel prices; however, we reserve the right to
                        re-negotiate any quoted delivery costs subject to
                        statutory increases.</p>
                     <p>Standing time would be charged by the transporter at a rate of R4, 950.00 per day per load
                        due to the site not being acceptable for offloading
                        purposes.</p>
                     <p>It is essential to ensure that 2 x 6m buildings are to be collected on a single 12m truck.
                        Any deviations to this at the time of collection could
                        result in additional cost.</p>
                     <p>Note that transport prices have been based on vehicle sizes and are quoted separately from
                        the rental rates of the buildings in the bill of
                        quantity.</p>
                     <p>Any additional moves on site will be for the account of the customer</p>
                  </ng-template>
               </ngb-panel>

               <ngb-panel id="static-8">
                  <ng-template ngbPanelTitle>
                     <span>Transportation Requirements</span>
                  </ng-template>
                  <ng-template ngbPanelContent>
                     <div class="row">
                        <div class="col-md-12 d-flex justify-content-center">
                           <img src="./assets/transport-requirements.png" height="400" class="mb-3" alt="transport">
                        </div>
                     </div>

                     <p><strong>Our vehicles cannot drive onto waterlogged grass and mud. OUR TRUCKS WILL GET
                           STUCK.</strong></p>
                     <p><strong>A site may not slope more than 200mm and the site is to be levelled before delivery can
                           take place. Signature below confirms the readiness of the site for
                           delivery/collection.</strong></p>
                     <p><strong>Provincial road permits are required for all loads wider than 2,6m. Permits specify that
                           we
                           are not allowed to travel before sunrise or after sunset, nor in adverse weather conditions,
                           nor over weekends.</strong></p>
                     <p><strong>The customer must inform us at least 7 working days in advance of any and all SAFETY
                           REQUIREMENTS related to the collection and delivery site, including safety files, medicals,
                           inductions and any other specified requirements.</strong></p>
                     <p><strong>THE CONTAINER/PARKHOME MUST BE EMPTY.</strong> Our Equipment and trucks are not designed
                        to handle weight over 4 ton inclusive of the Parkhome. Loose items inside the unit may cause
                        damage to your unit. We do not take responsibility for goods inside a unit other than equipment
                        ordered from Kwikspace.</p>
                     <p>It is the customer’s responsibility to ensure that the unit is in the correct place and in the
                        correct position, i.e. Doors facing the right way, before the unit is offloaded. Additional
                        moves on site are charged for.</p>
                     <p>Keys for the unit must be available in order to check that the unit is levelled
                        correctly.(Doorsand windows must be able to open and close with ease)</p>
                     <p>The unit must be in a good, solid condition. Old or poorly maintained units may not withstand
                        transportation.</p>
                     <p>If the unit is a double wide (two units joined together) it needs to be disassembled prior to
                        loading. Double wide units need even more open space for loading than standard units.</p>
                     <p>Unitsbeingdeliveredacrossthebordermusthaveallthenecessarydocumentation.Alldutiesand taxes must
                        be paid by the customer prior to the truck departing.</p>
                     <p>We do include limited Goods in Transit insurance in our price; however, excess payments will be
                        for the customer’s account.</p>
                     <p>From the time the vehicle arrives on site, a maximum of 1 (one) hour to load and 1 (one) hour to
                        offload is allowed, thereafter, standing time will be applicable. Rates do not include weekends
                        or public holidays.</p>
                     <p>All damages/shortages must be advised in writing at the time of arrival otherwise no claim will
                        be entertained. A note must be made by the customer and signed as well as countersigned by the
                        driver on the delivery/return note.</p>

                  </ng-template>
               </ngb-panel>

               <ngb-panel id="static-9">
                  <ng-template ngbPanelTitle>
                     <span>Positioning and Site Requirements</span>
                  </ng-template>
                  <ng-template ngbPanelContent>
                     <p>Level and compacted site, which does not slope more than 200mm over the area of the
                        buildings.</p>
                     <p>Our offer is contingent on the assumption that the ground conditions are firm and compact
                        enough to withstand possible penetration of the jacks when supporting the weight of the unit.
                     </p>
                     <p>Unrestricted access for a truck and trailer, minimum entrance and height requirement is 4,5
                        meters.</p>
                     <p>The jacking equipment requires clear space of at least 1m on all four corners of the unit for
                        the offloading.</p>
                     <p>Should the above requirements not be evident at the time of delivery we reserve the right to
                        negotiate additional charges that may be
                        necessary</p>
                  </ng-template>
               </ngb-panel>

               <ngb-panel id="static-10">
                  <ng-template ngbPanelTitle>
                     <span>Ownership</span>
                  </ng-template>
                  <ng-template ngbPanelContent>
                     <p>Rental buildings remain Kwikspace Modular Building’s property.</p>
                  </ng-template>
               </ngb-panel>

               <ngb-panel id="static-11">
                  <ng-template ngbPanelTitle>
                     <span>Insurance</span>
                  </ng-template>
                  <ng-template ngbPanelContent>
                     <p>In the event of the goods being lost, stolen, damaged or destroyed whether by an insured risk
                        or any other cause, the lessee shall immediately
                        notify the lessor.</p>
                     <p>In the event of a claim covered by the insurance, the lessee shall be responsible for any
                        excess applicable under the terms and conditions of
                        the lessor’s insurance policy</p>
                  </ng-template>
               </ngb-panel>

               <ngb-panel id="static-12">
                  <ng-template ngbPanelTitle>
                     <span>Exclusions (Unless specified on our quotation)</span>
                  </ng-template>
                  <ng-template ngbPanelContent>
                     <p>
                        <p>Design and execution of site clearing, including removal of trees and other vegetation.
                        </p>
                        <p>Design and execution of any earthworks.</p>
                        <p>Trenching and manhole excavations, filling, compaction and tests for foundations, water
                           pipes, fire-water pipes, sewer pipes, storm water pipes,
                           manholes, sumps, electrical cables, external light poles, sleeves for services and holes
                           for
                           external and internal fencing.</p>
                        <p>Design, supply and construction of all formwork, reinforcing, concrete and brick work.</p>
                        <p>Road works and walkways; compaction of road bases, road and walkway surfacing, retaining
                           structures, kerbing and road signs.</p>
                        <p>Fencing, gates and security booms (including the moving or repositioning of fences to gain
                           site access).</p>
                        <p>The design, supply and installation of all external electrical reticulation up to the
                           distribution board located inside the building.</p>
                        <p>The design, supply and installation of all external water reticulation up to the external
                           face of the building.</p>
                        <p>The design, supply and installation of all external sewer reticulation up to the external
                           face of the building.</p>
                        <p>Design, supply and installation of external lighting.</p>
                        <p>Design, supply and installation of telephone and data cables</p>
                        <p>Design, supply and installation of lightning protection</p>
                        <p>Fire extinguishers, equipment, sprinklers and signage thereof.</p>
                        <p>Furniture and equipment (incl air conditioners)</p>
                        <p>Required medicals, inductions and safety files</p>
                        <p>Rigging of the unit/s into place</p>
                        <p>Anchoring of units</p>
                        <p>Any municipal, local authority or similar compliance requirements and approvals shall be
                           secured by you in good time prior to any delivery or
                           installation work being commenced by us.</p>
                        <p>Security gates, burglar bars, fly screens and verandas.</p>
                        <p>Contractual requirements - performance bonds / guarantees etc.</p>
                        <p>Safety officer unless specified otherwise.</p>
                  </ng-template>
               </ngb-panel>

               <ngb-panel id="static-13">
                  <ng-template ngbPanelTitle>
                     <span>Warranty</span>
                  </ng-template>
                  <ng-template ngbPanelContent>
                     <p>The general terms and conditions of our Lease Agreement will apply.</p>
                     <p>The Lessee shall at its own expense, maintain the goods in good order during the currency of
                        the lease and shall return the goods in the same
                        good order, fair wear and tear accepted.</p>
                  </ng-template>
               </ngb-panel>

               <ngb-panel id="static-14">
                  <ng-template ngbPanelTitle>
                     <span>Air conditioner maintenance</span>
                  </ng-template>
                  <ng-template ngbPanelContent>
                     <p>The performance of any air conditioner is dependent on regular monthly cleaning.</p>
                     <p>Adequate airflow and ventilation is essential for the external unit to perform properly.</p>
                     <p>There should be no airflow restrictions around the fan.</p>
                     <p>Capacity might be limited due to extreme ambient conditions.</p>
                  </ng-template>
               </ngb-panel>
            </ngb-accordion>

            <div class="disclaimer mt-5 mb-3">
               <h4>Confidentiality and copyright</h4>
               <p class="mb-0">This proposal contains information, which is confidential and may only be disclosed to
                  your directors, employees and agents for purposes of
                  assessing Kwikspace’s suitability for this project.</p>
               <p class="mb-0">If Kwikspace is not the successful bidder, all proposal documents, must be returned or
                  destroyed. The ownership of and all rights in respect of
                  any patent, design, copyright, or proprietary know-how relating to building designs, floor plans
                  and renderings remains with Kwikspace Modular
                  Buildings (Pty) Ltd.</p>
               <p>These designs are and shall remain the property of Kwikspace and shall not be reproduced or
                  disseminated in any manner or form without prior
                  written consent.</p>

               <!-- <h4>Rental Term Acceptance</h4>

               <p>Disclaimer: I, <b>{{quote.customer.firstName}} {{quote.customer.lastName}}</b>, as a representative
                  of <b>{{quote.customer.company.name}}</b> company, confirm that the above
                  requirements have been met. I understand that my company will be held financially responsible
                  should the above requirements not be met. I
                  confirm that I am duly authorised to sign this document.</p> -->
            </div>
         </div>
      </div>

   </div>
</div>